import { render, staticRenderFns } from "./addMajor.vue?vue&type=template&id=5a244022&"
import script from "./addMajor.vue?vue&type=script&lang=js&"
export * from "./addMajor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports